import React, { useState, useRef } from 'react';
export function TiltingCard() {
  const cardRef = useRef<HTMLDivElement>(null);
  const [rotation, setRotation] = useState({
    x: 0,
    y: 0
  });
  const [glare, setGlare] = useState({
    x: 50,
    y: 50
  });
  const [isHovering, setIsHovering] = useState(false);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    // Maximum tilt angle in degrees
    const maxTilt = 15;
    // Calculate rotation based on mouse position relative to center
    const rotateX = -((y - centerY) / centerY) * maxTilt;
    const rotateY = (x - centerX) / centerX * maxTilt;
    setRotation({
      x: rotateX,
      y: rotateY
    });
    // Calculate glare position as a percentage
    setGlare({
      x: x / rect.width * 100,
      y: y / rect.height * 100
    });
  };
  const handleMouseEnter = () => {
    setIsHovering(true);
  };
  const handleMouseLeave = () => {
    setIsHovering(false);
    // Reset rotation and glare to center when mouse leaves
    setRotation({
      x: 0,
      y: 0
    });
    setGlare({
      x: 50,
      y: 50
    });
  };
  return <div className="relative perspective-[1000px] group" style={{
    perspective: '1000px'
  }} data-id="element-8">
      <div ref={cardRef} onMouseMove={handleMouseMove} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className={`
          relative w-80 h-[26rem] rounded-2xl overflow-hidden shadow-2xl bg-gray-900
          border border-gray-700/50 cursor-pointer
          ${isHovering ? 'transition-none duration-75' : 'transition-all duration-500 ease-out'}
        `} style={{
      transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
      transformStyle: 'preserve-3d'
    }} data-id="element-9">
        {/* Card Content Wrapper (moves slightly more for parallax effect) */}
        <div className="absolute inset-0 w-full h-full flex flex-col" style={{
        transform: 'translateZ(30px)'
      }} data-id="element-10">
          {/* Photo */}
          <div className="h-3/4 w-full overflow-hidden" data-id="element-11">
            <img src="https://cdn.shopify.com/s/files/1/0800/3606/9625/files/IMG_7126_3.jpg?v=1773455054" alt="Profile" className="w-full h-full object-cover object-top" draggable="false" data-id="element-12" />
          </div>

          {/* Info Section */}
          <div className="h-1/4 w-full bg-gradient-to-t from-gray-900 via-gray-900 to-gray-800/90 p-5 flex flex-col justify-center border-t border-gray-700/30" data-id="element-13">
            <h2 className="text-xl font-bold text-white tracking-wide" data-id="element-14">
              Agustín Desimone
            </h2>
            <p className="text-sm text-gray-400 mt-1 font-medium" data-id="element-15">
              AI Expert
            </p>
          </div>
        </div>

        {/* Glare Effect */}
        <div className={`
            absolute inset-0 pointer-events-none mix-blend-overlay
            ${isHovering ? 'opacity-100' : 'opacity-0'}
            transition-opacity duration-300
          `} style={{
        background: `radial-gradient(
              circle at ${glare.x}% ${glare.y}%, 
              rgba(255, 255, 255, 0.4) 0%, 
              rgba(255, 255, 255, 0) 60%
            )`
      }} data-id="element-16" />

        {/* Edge Highlight (subtle border glow) */}
        <div className="absolute inset-0 rounded-2xl border border-white/10 pointer-events-none" data-id="element-17" />
      </div>
    </div>;
}